import {
  TableCell,
  TableRow,
  Box,
  Typography,
  Hidden,
  FormControl,
  Select,
  IconButton,
  Chip,
  MenuItem,
  makeStyles,
  Collapse,
  List,
  ListItem,
} from "@material-ui/core";
import Toast from "../toast";
import { ExpandMoreRounded } from "@material-ui/icons";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { useState } from "react";
import { useDoctorsRefillCategories } from "../../hooks/useDoctorsRefillCategories";
export default function DoctorsRefillTableItem({
  _id,
  expand,
  fullName,
  rut,
  category,
  specialties,
  handleControlCollapse,
}) {
  const classes = useStyles();
  const [toast, setToast] = useState({ open: false, message: "" });

  const hasCategoryRefill = !!category;
  const products = hasCategoryRefill ? category.products : [];
  const doctorRefillCategory = category?._id ?? "";

  const [disabledEdit, setDisabledEdit] = useState(true);
  const {
    categories,
    updateDoctorCategory,
    addDoctorCategory,
    deleteDoctorCategory,
  } = useDoctorsRefillCategories();
  const [loading, setLoading] = useState(false);

  const handleChangeCategory = async (e) => {
    const value = e.target.value;
    setDisabledEdit(true);
    setLoading(true);
    let response = null;
    if (value === "" && hasCategoryRefill)
      response = await deleteDoctorCategory(_id);
    if (!hasCategoryRefill) {
      const doctorsToCategorize = [{ doctorId: _id }];
      response = await addDoctorCategory(value, doctorsToCategorize);
    }
    if (value !== "" && hasCategoryRefill)
      response = await updateDoctorCategory(_id, value);

    if (response) setToast({ open: true, message: "Actualizado exitosamente" });
    else {
      setToast({ open: true, message: "No se ha podido actualizar" });
    }
    setLoading(false);
  };
  return (
    <>
      <Toast
        open={toast.open}
        message={toast.message}
        close={() => setToast({ open: false, message: "" })}
      />
      <TableRow
        data-loading={loading ? "loading" : ""}
        data-type="row"
        data-state={expand ? "expand" : ""}
        className={classes.row}
      >
        <TableCell className={classes.cell} data-id="name">
          <Box className={classes.nameCell}>
            <Box>
              <IconButton onClick={() => handleControlCollapse(_id, false)}>
                <ExpandMoreRounded
                  style={{
                    transition: "transform 0.2s ease",
                    transform: expand ? "rotate(180deg)" : "rotate(0)",
                  }}
                />
              </IconButton>
            </Box>
            <Box data-id="rut">
              <Typography >{rut}</Typography>
            </Box>
            <Box>
              <Typography data-id="title">{fullName} </Typography>
            </Box>
          </Box>
        </TableCell>
        <TableCell className={classes.cell} data-id="especialidades">
          <Box>
            <Hidden smUp>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 600,
                  marginRight: 5,
                  lineHeight: 1.5,
                }}
              >
                Especialidades:
              </Typography>
            </Hidden>
            <Box display={"flex"} style={{ gap: 4, flexWrap: "wrap" }}>
              {specialties.map((spec) => (
                <Chip
                  key={spec._id}
                  label={spec.name}
                  color={"secondary"}
                  className={classes.chip_spc}
                />
              ))}
            </Box>
          </Box>
        </TableCell>
        <TableCell className={classes.cell} data-id="categoria">
          <Box>
            <Hidden smUp>
              <Typography
                variant="body2"
                style={{
                  fontWeight: 600,
                  marginRight: 5,
                  lineHeight: 1.5,
                }}
              >
                Categoria:
              </Typography>
            </Hidden>
            <FormControl
              className={classes.formControl}
              style={{ flexGrow: 1 }}
              variant="outlined"
              size="small"
              disabled={disabledEdit}
            >
              <Select
                className={classes.select}
                aria-label="category refill doctor"
                value={doctorRefillCategory}
                onChange={handleChangeCategory}
              >
                <MenuItem value="">
                  <em>Ninguna</em>
                </MenuItem>
                {categories?.map((cat) => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton onClick={() => setDisabledEdit((prev) => !prev)}>
              <EditOutlinedIcon />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
      <TableRow key={`row-collapsable-${_id}`} data-type="collapsable">
        <TableCell style={{ padding: 0, overflow: "hidden" }} colSpan={3}>
          <Collapse in={expand}>
            <Box className={classes.collapse_content}>
              {hasCategoryRefill ? (
                <List>
                  <ListItem className={classes.list_item} data-id="header-list">
                    <Box className={classes.list_content}>
                      <Typography>Nombre producto</Typography>
                      <Typography data-id="qty">Cantidad</Typography>
                    </Box>
                  </ListItem>
                  {products.map((item) => {
                    const {
                      refillTo,
                      product: { _id: productId, name: productName },
                    } = item;
                    return (
                      <ListItem
                        key={`${_id}-${productId}`}
                        className={classes.list_item}
                      >
                        <Box className={classes.list_content}>
                          <Typography>{productName}</Typography>
                          <Typography data-id="qty">{refillTo}</Typography>
                        </Box>
                      </ListItem>
                    );
                  })}
                </List>
              ) : (
                <Typography>No posee una categoria asignada</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(0.5),
  },
  nameCell: {
    display: "grid",
    gridTemplateColumns: "0.25fr 0.5fr 1fr",
    alignItems: "center",
    justifyItems: "start",
    [theme.breakpoints.down("xs")]: {
      '& p[data-id="title"]': {
        fontSize: "1.08rem",
      },
    },
  },
  collapse_content: {
    paddingInline: theme.spacing(3),
    textAlign: "start",
  },
  list_item: {
    padding: 0,
    borderBottom: `1pt solid ${theme.palette.grey[300]}`,
    '&[data-id="header-list"]': {
      backgroundColor: `hsl(from ${theme.palette.secondary.main} h s calc(l + 50))`,
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  list_content: {
    display: "grid",
    gridTemplateColumns: "1fr 0.5fr",
    gap: theme.spacing(1.5),
    width: "100%",
    '& [data-id="qty"]': {
      justifySelf: "end",
    },
  },
  select: {
    borderRadius: 32,
    "& .MuiSelect-outlined": {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
  },
  chip_spc: {
    flexGrow: 1,
    flexBasis: "fit-content",
    textTransform: "capitalize",
    height: "auto",
    "& >span": {
      whiteSpace: "break-spaces",
      wordBreak: "break-word",
    },
  },
  formControl: {},
}));
